// API Configuration
// This file centralizes all API endpoints and configuration


// Get API base URL from environment variables or fallback to production API
const apiBaseUrl = import.meta.env.VITE_API_BASE_URL || 'https://doodlecart.onrender.com/api';

// Export configuration object
export const config = {
  api: {
    baseUrl: apiBaseUrl,
    endpoints: {
      auth: {
        googleLogin: '/auth/google-login'
      },
      wishlist: {
        get: (userId) => `/wishlist/${userId}`,
        add: '/wishlist/add',
        remove: '/wishlist/remove'
      },
      affiliate: {
        click: '/affiliate/click'
      },
      user: {
        createTestUser: '/test/create-test-user'
      }
    }
  }
};

// Export individual constants for backward compatibility
export const API_BASE_URL = config.api.baseUrl;
